
import {defineComponent} from "vue";
import ContentDoubtsList from "./ContentDoubtsList.vue";
import ContentDoubtsForm from "./ContentDoubtsForm.vue";

export default defineComponent({
  name: "ContentDoubts",
  components: {ContentDoubtsForm, ContentDoubtsList},
});
